import { Flex, Typography } from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/redux-hooks";
import { useAudioStatusCheck } from "../../hooks/useAudioStatusCheck";
import { getNotesList } from "../../service/notes.service";
import { setCurrentPage, setLoadingNotesState } from "../../slices/appStateSlice";
import { eventEmitter } from "../../utils/eventEmitter";
import ClientSelector from "./ClientSelector.component";
import NotesSection from "./NotesSection.component";
import styles from "./home.module.scss";

const AllNotes = () => {
  const componentName = "home";
  const dispatch = useAppDispatch();
  const { notes, updateNotes: setNotes } = useAudioStatusCheck([]);
  const [totalNotes, setTotalNotes] = useState(0);
  const [filterMode, setFilterMode] = useState<string>("own");
  const abortControllerRef = useRef<AbortController | null>(null);
  const { isNotesViewVisible, currentPage, selectedClient } = useAppSelector((state) => state.appState);

  const fetchNotes = useCallback(
    async (pageNumber = 1) => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }

      abortControllerRef.current = new AbortController();
      try {
        dispatch(setLoadingNotesState(true));
        const response = await getNotesList(pageNumber, abortControllerRef.current.signal, filterMode);
        const data = await response.data;
        setNotes(data?.results);
        setTotalNotes(data?.count);
        if (pageNumber) {
          dispatch(setCurrentPage(pageNumber));
        }
      } catch (error) {
        console.error("Error fetching notes:", error);
      } finally {
        dispatch(setLoadingNotesState(false));
      }
    },
    [dispatch, setNotes, filterMode],
  );

  useEffect(() => {
    if (!isNotesViewVisible) {
      fetchNotes(currentPage);
    }
  }, [currentPage, fetchNotes, isNotesViewVisible]);

  useEffect(() => {
    if (!isNotesViewVisible) {
      fetchNotes(1);
    }
  }, [filterMode, isNotesViewVisible, fetchNotes]);

  const refreshHandler = useCallback(() => {
    fetchNotes(currentPage);
  }, [fetchNotes, currentPage]);

  useEffect(() => {
    eventEmitter.on("refreshNotes", refreshHandler);

    return () => {
      eventEmitter.off("refreshNotes", refreshHandler);
    };
  }, [refreshHandler]);

  const handleFilterChange = (value: string | number) => {
    setFilterMode(value as string);
    dispatch(setCurrentPage(1));
  };

  return (
    <Flex className={!isNotesViewVisible ? styles[`${componentName}__container-left-allnotes`] : ""} vertical>
      {!selectedClient && !isNotesViewVisible ? (
        <Flex className={styles[`${componentName}__container-left-header`]}>
          {/* <Segmented
            options={[
              { label: "My Notes", value: "own" },
              { label: "Shared Notes", value: "shared" },
            ]}
            value={filterMode}
            onChange={handleFilterChange}
          /> */}
          <Typography className={styles[`${componentName}__container-left-header-title`]}>My Notes</Typography>
          <ClientSelector />
        </Flex>
      ) : null}
      <NotesSection notes={notes} setNotes={setNotes} totalNotes={totalNotes} fetchNotes={fetchNotes} />
    </Flex>
  );
};

export default AllNotes;
